<template>
  <div class="view about">
    <section class="banner">
      <div class="banner-background">
        <img v-if="!isMobile" src="@/assets/cast_resources_banner.png">
      </div>
      <div class="wrapper">
        <div class="page-title">
          <svg v-if="!isMobile" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="191.434" height="199.511" viewBox="0 0 191.434 199.511"><defs><filter id="a" x="0" y="0" width="177.89" height="184.54" filterUnits="userSpaceOnUse"><feOffset dy="12" input="SourceAlpha"/><feGaussianBlur stdDeviation="9.5" result="b"/><feFlood flood-opacity="0.078"/><feComposite operator="in" in2="b"/><feComposite in="SourceGraphic"/></filter><filter id="c" x="119.434" y="39.511" width="72" height="72" filterUnits="userSpaceOnUse"><feOffset dy="12" input="SourceAlpha"/><feGaussianBlur stdDeviation="9.5" result="d"/><feFlood flood-opacity="0.078"/><feComposite operator="in" in2="d"/><feComposite in="SourceGraphic"/></filter><filter id="e" x="21.434" y="127.511" width="72" height="72" filterUnits="userSpaceOnUse"><feOffset dy="12" input="SourceAlpha"/><feGaussianBlur stdDeviation="9.5" result="f"/><feFlood flood-opacity="0.078"/><feComposite operator="in" in2="f"/><feComposite in="SourceGraphic"/></filter></defs><g transform="translate(-317.066 -316.989)"><g transform="matrix(1, 0, 0, 1, 317.07, 316.99)" filter="url(#a)"><path d="M71.59-7.113C113.855-11.551,96.762,21.832,120,60s-3.5,74.168-54.793,54.457S-4.125,96.16,15.039,60,29.324-2.676,71.59-7.113Z" transform="translate(20.93 24.01)" fill="#0d988c"/></g><g transform="matrix(1, 0, 0, 1, 317.07, 316.99)" filter="url(#c)"><circle cx="7.5" cy="7.5" r="7.5" transform="translate(147.93 56.01)" fill="#0d988c"/></g><g transform="matrix(1, 0, 0, 1, 317.07, 316.99)" filter="url(#e)"><circle cx="7.5" cy="7.5" r="7.5" transform="translate(49.93 144.01)" fill="#0d988c"/></g></g></svg>
          <h1>Resources</h1>
          <p v-if="page" v-html="page.headline.replace(/\n/g, '<br>')"></p>
        </div>
      </div>
    </section>
    <section class="files-section">
      <div class="wrapper">
        <div class="files">
          <div class="file" :cover="file.use_cover" v-for="file in files" :key="file.id">
            <div class="file-container">
              <div class="file-header">
                <img class="logo" src="@/assets/cast_logo-b.svg" alt="CAST Project">
                <div class="file-type">{{file.ext}}</div>
              </div>
              <div class="file-info" :style="file.use_cover ? getPreview(file) : null">
                <div class="file-name">{{file.use_cover ? '' : file.title}}</div>
                <div class="file-actions">
                  <a :href="file.url" target="_blank" class="btn">Download<svg xmlns="http://www.w3.org/2000/svg" width="14" height="16.333" viewBox="0 0 14 16.333"><g transform="translate(-4 -2)"><path d="M17.667,9.583l-.823-.822-4.427,4.422V2H11.25V13.182L6.822,8.761,6,9.583l5.833,5.833Z" transform="translate(-0.833)" fill="currentColor"/><path d="M16.833,24v2.333H5.167V24H4v2.333A1.167,1.167,0,0,0,5.167,27.5H16.833A1.167,1.167,0,0,0,18,26.333V24Z" transform="translate(0 -9.167)" fill="currentColor"/></g></svg></a>
                </div>
              </div>
            </div>
            <div class="file-details">
              <div class="file-name"><a :href="file.url" target="_blank">{{file.title}}</a></div>
              <div class="file-author">by {{file.author}}</div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <Newsletter />
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import Newsletter from '../components/Newsletter'

export default {
  name: 'about',
  components: {
    Newsletter
  },
  computed: {
    ...mapGetters({
      isMobile: 'getMobile',
      db: 'getDb'
    })
  },
  data() {
    return {
      page: null,
      files: []
    }
  },
  methods: {
    getPreview(file) {
      if(file.type === 'image') return {background: `#fff url(${file.url}) no-repeat center/cover`}
      else if(file.ext === 'pdf' && file.preview) return {background: `url(${file.preview}) no-repeat top center/cover`}
      return null
    }
  },
  mounted: function() {
    this.pageRef = this.db().collection('settings').doc('resources').onSnapshot(page => {
      this.page = page.data()
    })
    this.filesRef = this.db().collection('files').onSnapshot(files => {
      this.files = files.docs.map(file => file.data()).sort((a, b) => a.name.localeCompare(b.name))
      this.preloadImages([
        require('@/assets/cast_resources_banner.png'),
        require('@/assets/cast_resources_footer.png'),
      ])
      .then(() => {
        this.$store.commit('setPageLoading', false)
      })
      .catch(() => {
        this.$store.commit('setPageLoading', false)
      })
    })
  },
  beforeDestroy: function() {
    if(this.pageRef) this.pageRef()
    if(this.filesRef) this.filesRef()
  }
}
</script>

<style scoped>
.about {
  padding-top: 236px;
  /* background: url(../assets/cast_about_banner.jpg) no-repeat top center/1920px auto; */
}

.banner .banner-background {
  position: absolute;
  top: 0;
  width: 1920px;
  left: 50%;
  transform: translateX(-50%);
}

.banner .banner-background svg,
.banner .banner-background img {
  position: absolute;
  top: 0;
  left: 0;
  display: block;
  width: 100%;
  height: auto;
}

.page-title {
  position: relative;
  color: #fff;
  padding-left: 202px;
  margin-bottom: 72px;
}

.page-title > svg {
  position: absolute;
  top: -32px;
  left: 105px;
}

.page-title h1 {
  position: relative;
  font: bold 3.21em/1 'Butler';
  margin-bottom: 8px;
}

.page-title p {
  position: relative;
  width: 500px;
  max-width: 100%;
}

.files-section .wrapper {
  width: 1074px;
}

.files {
  display: flex;
  flex-flow: row wrap;
  margin: 0 -38px;
  min-height: 420px;
}

.files .file {
  width: 307px;
  margin: 0 38px 54px;
}

.files .file .file-container {
  position: relative;
  background: #fff;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 12px 24px rgba(0,0,0,.08);
}

.files .file .file-header {
  display: flex;
  height: 96px;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
}

.files .file .file-header img {
  width: 154px;
}

.files .file .file-header .file-type {
  font-size: 10px;
  font-weight: bold;
  text-transform: uppercase;
  opacity: .5;
}

.files .file .file-info {
  display: flex;
  flex-flow: column nowrap;
  justify-content: space-between;
  height: 340px;
  padding: 36px 20px 20px;
  color: #fff;
  background-color: #0D988C;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: top center;
}

.files .file .file-info .file-name {
  font-size: 32px;
  line-height: 1.1875;
  font-weight: bold;
  word-break: break-word;
}

.files .file .file-info .file-actions {
  text-align: right;
}

.files .file .file-info .btn {
  height: 36px;
  line-height: 36px;
  border-radius: 18px;
  background: none;
  border: 1px solid #fff;
  font-size: 14px;
  text-transform: none;
  font-weight: normal;
  padding: 0 24px;
  min-width: 0;
  transition: all .16s;
}

.files .file[cover] .file-info .btn {
  background: #fff;
  color: #0D988C;
  border-color: #0D988C;
}

@media screen and (min-width: 1025px) {
  .files .file .file-info .btn:hover {
    background: #fff;
    color: #0D988C;
  }
  .files .file[cover] .file-info .btn:hover {
    background: #0D988C;
    color: #fff;
  }
}

.files .file .file-info .btn svg {
  width: 16px;
  height: 16px;
  margin-left: 12px;
}

.files .file .file-details {
  margin-top: 20px;
}

.files .file .file-details .file-name {
  font-size: 22px;
  line-height: 1.27;
  font-weight: 600;
}

.files .file .file-details .file-name a {
  color: inherit;
}

.files .file .file-details .file-author {
  opacity: .5;
}

@media screen and (max-width: 1310px) {
  
}

@media screen and (max-width: 1135px) {
  .files-section .wrapper {
    width: 690px;
  }
}

@media screen and (max-width: 1024px) {
  .project,
  .page-title {
    color: #343434;
  }
  .page-title {
    display: block;
    padding: 0;
    text-align: center;
  }
  .page-title h1 {
    color: #0D988C;
    height: 32px;
  }
  .page-title p {
    width: 420px;
    margin: auto;
  }
}

@media screen and (max-width: 752px) {
  .files {
    flex-flow: column nowrap;
    align-items: center;
    margin: 0;
  }
}

@media screen and (max-width: 704px) {
  
}

@media screen and (max-width: 580px) {
  
}

@media screen and (max-width: 400px) {
  
}
</style>

